module.exports = "<div id=\"qrcode\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/qrcode/qrcode.component.html
// module id = ./src/app/qrcode/qrcode.component.html
// module chunks = main